/*
 * Developed by HuMingZhi on 6/11/19 11:34 AM
 * Copyright (c) 2019. All right reserved.
 */
import { isProductionMode } from './mode';
/**
 * @description 用于格式化信息展示
 * @param {'warning'|'error'|'fatal'} msgType 日志类型
 * @param {string} msg 信息内容
 * @param {string} dir 具体位置信息
 * @todo 具体区分日志类型，尽量在开发阶段给出足够提示
 */
export var log = function (msgType, msg) {
    var dir = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        dir[_i - 2] = arguments[_i];
    }
    if (!isProductionMode) {
        console.warn('【fe-mobile-lib】: ', dir, msgType, msg);
    }
};
